import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
interface LayoutProps {
  children: ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-background text-foreground selection:bg-[#D4AF37] selection:text-black" data-id="element-424" data-mp="2vcs65fgcgizq">
      <ScrollToTop data-id="element-425" data-mp="305ldmb3765fi" />
      <Navbar data-id="element-426" data-mp="353ddpsdzwxus" />
      <main className="flex-grow" data-id="element-427" data-mp="353n2jcnb0yyw">{children}</main>
      <Footer data-id="element-428" data-mp="352vc0g8kdrfh" />
    </div>;
}